import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'
import Grid from '@mui/material/Grid2'

const SkeletonContent = () => {
  return (
    <Stack spacing={4}>
      <Stack>
        <Skeleton variant="text" height={20} width={200} />
        <Skeleton variant="text" height={20} width={150} />
      </Stack>
      <Grid container spacing={2}>
        <Grid size={12}>
          <Skeleton variant="rounded" height={70} />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        {[...Array(4)].map((_, index) => (
          <Grid key={index} size={{ xs: 12, lg: 3 }}>
            <Skeleton variant="rounded" height={110} />
          </Grid>
        ))}
      </Grid>
      <Grid container spacing={2}>
        {[...Array(2)].map((_, index) => (
          <Grid key={index} size={{ xs: 12, lg: 6 }}>
            <Skeleton variant="rounded" height={360} />
          </Grid>
        ))}
      </Grid>
      <Grid container spacing={2}>
        <Grid size={12}>
          <Skeleton variant="rounded" height={520} />
        </Grid>
      </Grid>
    </Stack>
  )
}

export default SkeletonContent
